import { Text } from '@kanda-libs/ks-design-library';

import JobQuote from 'components/JobQuote';
import useBreakpoint from 'hooks/useBreakpoint';

import QuoteChangesReceived from './QuoteChangesReceived';
import QuoteChangesRequested from './QuoteChangesRequested';
import useQuote from './useQuote';

import JobActionButtons from '../JobActionButtons';

const JobContentQuote: React.FunctionComponent = function () {
  const {
    isLoading,
    job,
    jobCompanyInfo,
    from,
    showChangesRequested,
    showChangesReceived,
  } = useQuote();
  const underBreakpoint = useBreakpoint(640);
  return (
    <div className="flex flex-col gap-y-3 md:gap-y-4 w-full max-w-3xl mx-auto mb-4 md:mb-10">
      <Text
        isLoading={isLoading}
        text={from}
        className="text-20-24-em md:text-32-40-em"
      />
      <Text
        isLoading={isLoading}
        text="Review the details and choose an option below"
        className="text-14-22 md:text-16-24 text-neutral-700"
      />
      {showChangesRequested && <QuoteChangesRequested />}
      {showChangesReceived && <QuoteChangesReceived />}
      <div className="mt-2 md:mt-6">
        <JobQuote
          job={job}
          jobCompanyInfo={jobCompanyInfo}
          isLoading={isLoading}
          footer={
            underBreakpoint ? null : (
              <div className="hidden sm:flex px-6 py-5">
                <JobActionButtons />
              </div>
            )
          }
        />
      </div>
    </div>
  );
};

export default JobContentQuote;
